import { supabase, run } from './db';
import { cached } from './local/cache';

/**
 * Técnicos do laboratório.
 *
 * Quem executa OPU, FIV e DG. Não é usuário do sistema de propósito: o técnico
 * de campo raramente tem login, e exigir conta para registrar quem fez o
 * procedimento levaria a criar contas fantasma só para preencher o campo.
 *
 * As sessões já gravavam `technician_id` ao lado de um `technician_name` de
 * texto livre — o campo estava lá esperando ter de onde puxar.
 */

/** Ativos primeiro, em ordem alfabética: é uma lista para escolher numa tela. */
export const listTechnicians = (laboratoryId) =>
  cached(`technicians:${laboratoryId}`, () => run(supabase
    .from('technicians')
    .select('*')
    .eq('laboratory_id', laboratoryId)
    .order('active', { ascending: false })
    .order('name')));

export const insertTechnician = (row) =>
  run(supabase.from('technicians').insert([row]).select().single());

export const updateTechnician = (id, updates) =>
  run(supabase.from('technicians').update(updates).eq('id', id));

/**
 * Desativar e excluir servem a coisas diferentes.
 *
 * Desativar é para quem saiu da equipe: some da seleção e continua respondendo
 * pelo que executou. Excluir é para cadastro errado ou duplicado, que nunca
 * deveria ter existido.
 *
 * Excluir é seguro aqui porque a sessão grava o NOME junto com o id — o
 * histórico continua legível sem a linha. Se guardasse só o id, apagar
 * transformaria "quem fez a TE" em vazio.
 */
export const deactivateTechnician = (id) =>
  run(supabase.from('technicians').update({ active: false }).eq('id', id));

export const reactivateTechnician = (id) =>
  run(supabase.from('technicians').update({ active: true }).eq('id', id));

export const deleteTechnician = (id) =>
  run(supabase.from('technicians').delete().eq('id', id));
